import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React from 'react';
import styled from 'styled-components';

export function LoadingSpinnerIndicator() {
  return (
    <StyledSpinner>
      <LoadingOutlined style={{ fontSize: 24 }} spin />
    </StyledSpinner>
  );
}

type LoadingSpinnerProps = React.HTMLAttributes<HTMLDivElement>;

export default function LoadingSpinner(props: LoadingSpinnerProps) {
  return (
    <div {...props} style={{ position: 'relative', height: '100%', ...(props.style ?? {}) }}>
      <StyledSpinner>
        <Spin indicator={<LoadingSpinnerIndicator />} />
      </StyledSpinner>
    </div>
  );
}

const StyledSpinner = styled.div`
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
`;
